export type TemplateValues = Record<string, string | number | null | undefined>;

export function applyTemplate(template: string, values: TemplateValues): string {
  if (template.length === 0) {
    return '';
  }

  return template.replace(/\{(\w+)\}/g, (_match, key: string) => {
    const value = values[key];
    if (value === null || value === undefined) {
      return '';
    }
    return String(value);
  });
}
